// extracted by mini-css-extract-plugin
module.exports = {"search-btns":"index_search-btns__1GvZM","expand-btn":"index_expand-btn__3cpuE"};